const messageKeys = [
  'ABILITY_EXECUTED',
  'AI_TURN',
  'BATTLE_EVENT',
  'BATTLE_STATE',
  'CAVERNS_BATTLE_INITIALIZED',
  'CAVERNS_BREAKING_ERROR',
  'CAVERNS_PORTAL_LEVEL_SET',
  'CAVERNS_TRAVEL_STARTED',
  'CAVERNS_TRAVEL_SUCCESS',
  'ENTERED_CAVERNS',
  'GOT_UNIT_STATE',
  'MISSING_CAVERNS_RUN_DATA',
  'PARTY_DEFEATED',
  'PASSIVE_YIELDS_CLAIMED',
  'RETURNED_TO_SURFACE',
  'ROOM_IS_CLEAR',
  'STAT_COSTS_EXACTED',
  'TOTAL_LOOT_PICKED_UP',
  'UNFINISHED_CAVERNS_RUN',
  'UNIT_CONDITION',
  'UNIT_CONDITION_EXPIRED',
];

const messages: Record<CavernsStoreMessage, CavernsStoreMessage> = Object.fromEntries(
  messageKeys.map((k) => [k, k])
) as Record<CavernsStoreMessage, CavernsStoreMessage>;
export default messages;

export type CavernsStoreMessage = (typeof messageKeys)[number];
